module.exports = __webpack_public_path__ + "img/ConectaSuiteBrancoFull.740230f4.png";